import { render, staticRenderFns } from "./FailedContactModal.vue?vue&type=template&id=cc6ba4b4&scoped=true"
import script from "./FailedContactModal.vue?vue&type=script&lang=js"
export * from "./FailedContactModal.vue?vue&type=script&lang=js"
import style0 from "./FailedContactModal.vue?vue&type=style&index=0&id=cc6ba4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6ba4b4",
  null
  
)

export default component.exports